export const GET_EMAIL_CONTENTS = 'GET_EMAIL_CONTENTS';
export const SET_EMAIL_CONTENTS = 'SET_EMAIL_CONTENTS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_EMAIL_CONTENT = 'SET_EMAIL_CONTENT';
export const ADD_EMAIL_CONTENT = 'ADD_EMAIL_CONTENT';
export const EMPTY_EMAIL_CONTENT = 'EMPTY_EMAIL_CONTENT';
export const DELETE_EMAIL_CONTENT = 'DELETE_EMAIL_CONTENT';
export const EDIT_EMAIL_CONTENT = 'EDIT_EMAIL_CONTENT';
export const UPDATE_EMAIL_CONTENT = 'UPDATE_EMAIL_CONTENT';
export const SET_EMAIL_CONTENT_FILTER = 'SET_EMAIL_CONTENT_FILTER';